import { render } from "./ChangeOwnerComponent.vue?vue&type=template&id=29e585f2&scoped=true"
import script from "./ChangeOwnerComponent.vue?vue&type=script&lang=js"
export * from "./ChangeOwnerComponent.vue?vue&type=script&lang=js"

import "./ChangeOwnerComponent.vue?vue&type=style&index=0&id=29e585f2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e585f2"]])

export default __exports__